import { AsyncPipe } from '@angular/common';
import { DOCUMENT } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatProgressBar } from '@angular/material/progress-bar';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { distinctUntilChanged, filter, map, Subject, Subscription } from 'rxjs';

import { environment } from '../environments/environment';
import { AppService } from './app.service';
export let browserRefresh = new Subject<Boolean>();
@Component({
  selector: 'glx-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [MatProgressBar, RouterOutlet, AsyncPipe],
})
export class AppComponent implements OnInit {
  private router = inject(Router);
  private doc = inject(DOCUMENT);

  subscription: Subscription;
  appService = inject(AppService);
  isLoading$ = this.router.events.pipe(
    filter(
      event =>
        event instanceof NavigationStart ||
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
    ),
    map(event => event instanceof NavigationStart),
    distinctUntilChanged()
  );

  constructor() {
    this.subscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.appService.browserUpdated(!this.router.navigated);
      }
    });
  }

  ngOnInit(): void {
    this.updateFavicon(environment.favicon);
  }

  private updateFavicon(faviconUrl: string): void {
    let link: HTMLLinkElement | null =
      this.doc.querySelector("link[rel*='icon']");

    if (!link) {
      link = this.doc.createElement('link');
      link.setAttribute('rel', 'icon');
      this.doc.head.appendChild(link);
    }

    link.type = 'image/x-icon';
    link.href = faviconUrl;
  }
}
